export const PalmTree = () => {
  return (
    <svg width='67' height='35' viewBox='0 0 67 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M33.5 16.5C33.5 7.66344 25.8366 0.5 17 0.5C8.16344 0.5 1 7.66344 1 16.5M33.5 34.5V17C33.5 11.201 28.299 6.5 22.5 6.5C16.701 6.5 12 11.201 12 17C12 22.799 14.1 27.5 22.5 27.5'
        stroke='currentColor'
        strokeWidth='1'
      />
      <path
        d='M33.5 16.5C33.5 7.66344 41.1634 0.5 50 0.5C58.8366 0.5 66 7.66344 66 16.5M33.5 34.5V17C33.5 11.201 38.701 6.5 44.5 6.5C50.299 6.5 55 11.201 55 17C55 22.799 52.9 27.5 44.5 27.5'
        stroke='currentColor'
        strokeWidth='1'
      />
    </svg>
  );
};
